import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getDataSession } from '../../services/auth-service';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  getDataSessionFailure,
  getDataSessionRequest,
  getDataSessionSuccess,
  refreshDataSessionRequest,
} from '../slices/main-slice';
import { RootState } from '@/core/redux';

const selectAuthInfo = (state: RootState) => ({
  token: state.auth.main.token,
  clientId: state.auth.main.clientId,
});

function* getDataSessionSaga(
  action: PayloadAction<{ token: string; clientId: string }>
) {
  const response: Awaited<ReturnType<typeof getDataSession>> = yield call(
    getDataSession,
    action.payload.token,
    action.payload.clientId
  );
  if (response.data) {
    yield put(getDataSessionSuccess(response.data));
  } else {
    yield put(
      getDataSessionFailure(response.message || 'Failed to get data session')
    );
  }
}

function* refreshDataSessionSaga() {
  const { token, clientId } = yield select(selectAuthInfo);
  const response: Awaited<ReturnType<typeof getDataSession>> = yield call(
    getDataSession,
    token,
    clientId
  );
  if (response.data) {
    yield put(getDataSessionSuccess(response.data));
  } else {
    yield put(
      getDataSessionFailure(
        response.message || 'Failed to refresh data session'
      )
    );
  }
}

export function* mainSaga() {
  yield takeLatest(getDataSessionRequest.type, getDataSessionSaga);
  yield takeLatest(refreshDataSessionRequest.type, refreshDataSessionSaga);
}
